export default "__VITE_ASSET__Cly6Cq$T__"